module.exports = __webpack_public_path__ + "static/media/homepage-book-blob.b42876a9.png";